<script setup lang="ts">
    import { computed } from "vue";
    import { useStore } from "@/store";

    const store = useStore();
    const systemData = computed(() => store.state.systemData);
</script>

<template>
    <section class="system-information">
        <header class="system-information__header">
            <div class="">Systeminformation</div>
            <h2>Kliniken</h2>
            <p>Kliniken Patientsystem AB</p>
            <div class=""><span class="bold-label">UDI-DI </span>{{ systemData.udiDi }}</div>
            <div class=""><span class="bold-label">Version/UDI-PI </span>{{ systemData.systemVersion }}</div>
        </header>

        <div class="spacer-line"></div>

        <section class="details">
            <h2 class="">Kontakta vår support</h2>
            <div class="details__text">
                Öppettider vardagar 07:00 – 17:00<br />
                (lunchstängt 11:45 – 12:30)
            </div>

            <div class="spacer"></div>

            <div class="details__text">
                Vi rekommenderar mejl för icke brådskande ärenden <br />
                – då får du hjälp av rätt expert. <br />
                Behöver du akut hjälp, ring oss.
            </div>

            <div class="spacer"></div>

            <div class="support">
                <div class="support__item">
                    <img src="@/assets/phone_blue.svg" alt="phone" />
                    <span class="bold-label">Telefon för akuta ärenden</span>
                    <a href="tel:+46701650690"> 0701-650 690</a>
                </div>

                <div class="support__item">
                    <img src="@/assets/mail_blue.svg" alt="mail" />
                    <span class="bold-label">E-post för övriga ärenden</span>
                    <a href="mailto:support@kliniken3.se"> support@kliniken3.se</a>
                </div>

                <div class="support__item">
                    <img src="@/assets/statusatthantera_blue.svg" alt="statushantera" />
                    <span class="bold-label">Mer information </span>
                    <a href="https://kliniken3.se" target="_blank">kliniken3.se</a>
                </div>
            </div>
        </section>
    </section>
</template>
<style lang="scss" scoped>
    @import "@/style/variables";

    .system-information {
        color: $dark-text-color;
        .bold-label {
            font-weight: 700;
            font-family: Roboto Medium, sans-serif;
        }
        .spacer {
            height: 2rem;
        }
        .spacer-line {
            margin-top: 2rem;
            margin-bottom: 2rem;
            height: 1px;
            background-color: $list-border-color;
        }
        .details {
            &__text {
                line-height: 22px;
            }
            .support {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                &__item {
                    display: flex;
                    gap: 8px;
                    line-height: 22px;
                    a {
                        color: $color-navigation;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>
